import { Navigate } from 'react-router-dom';

import { useAuth } from '@alamo/auth';

interface ConsultorOnlyRouteProps {
  children: React.ReactNode;
}

/**
 * Gate for routes that belong exclusively to CONSULTANTS (any type).
 *
 * Redirects:
 *  - admin_alamo → /admin/network (admins have no consultant_profile)
 *  - gerente     → /admin/registrations (no dedicated landing yet)
 *
 * CLT passes through: hierarchy is type-free (decisão 2026-07-09) — an
 * internal consultant can lead a team and refer people below them.
 */
export function ConsultorOnlyRoute({ children }: ConsultorOnlyRouteProps) {
  const { roleName } = useAuth();

  if (roleName === 'admin_alamo') {
    return <Navigate to="/admin/network" replace />;
  }
  if (roleName === 'gerente') {
    return <Navigate to="/admin/registrations" replace />;
  }
  return <>{children}</>;
}
